import type { Paginated, ParticipantContactBody, ParticipantContactResult, ParticipantEvent, ParticipantMedal, ParticipantProfile } from "@seagames/contracts";
import { queryOptions } from "@tanstack/react-query";
import { api } from "./client";

/** A participant's own pages (`/me`, active role PARTICIPANT). */

export const meKeys = {
	all: ["me"] as const,
	profile: () => ["me", "profile"] as const,
	events: (page: number) => ["me", "events", page] as const,
	medals: () => ["me", "medals"] as const,
};

export const meProfileQuery = queryOptions({
	queryKey: meKeys.profile(),
	queryFn: () => api.get<ParticipantProfile>("/me/profile"),
	staleTime: 60_000,
});

export const meEventsQuery = (page: number) =>
	queryOptions({
		queryKey: meKeys.events(page),
		queryFn: () => api.get<Paginated<ParticipantEvent>>(`/me/events?page=${page}`),
	});

export const meMedalsQuery = queryOptions({
	queryKey: meKeys.medals(),
	queryFn: () => api.get<{ items: ParticipantMedal[] }>("/me/medals"),
});

export const updateMyContact = (body: ParticipantContactBody) => api.patch<ParticipantContactResult>("/me/profile", body);
